import { globalWindow } from './global';
export var isMiniAli = typeof my !== 'undefined' && !!my && typeof my.showToast === 'function';
var system;
var platform;
var language;

if (isMiniAli) {
  var myOptions = my.getSystemInfoSync();
  system = myOptions.system;
  platform = myOptions.platform;
  language = myOptions.language;
} else {
  var browser = {
    versions: function () {
      var u = globalWindow.navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') === -1,
        weixin: u.indexOf('MicroMessenger') > -1,
        qq: u.match(/\sQQ/i) === ' qq'
      };
    }(),
    language: (globalWindow.navigator.browserLanguage || globalWindow.navigator.language).toLowerCase()
  };

  if (browser.versions.android) {
    platform = 'android';
  } else if (browser.versions.trident) {
    platform = 'IE';
  } else if (browser.versions.presto) {
    platform = 'Opera';
  } else if (browser.versions.webKit) {
    platform = 'webKit';
  } else if (browser.versions.gecko) {
    platform = 'Firefox';
  } else if (browser.versions.mobile) {
    platform = 'mobile';
  } else if (browser.versions.ios) {
    platform = 'ios';
  } else if (browser.versions.iPhone) {
    platform = 'iPhone';
  } else if (browser.versions.iPad) {
    platform = 'ipad';
  } else if (browser.versions.webApp) {
    platform = 'webApp';
  } else if (browser.versions.weixin) {
    platform = 'weixin';
  } else if (browser.versions.qq) {
    platform = 'qq';
  }

  system = globalWindow.navigator.userAgent;
  language = browser.language;
}

var android = system.toLowerCase().indexOf('android') !== -1;
var uaDesc = android ? 'Android; CPU Android 6.0' : 'iPhone; CPU iPhone OS 10_3_1 like Mac OS X';
var ua = "Mozilla/5.0 (".concat(uaDesc, ") AppleWebKit/603.1.30 (KHTML, like Gecko) Mobile/14E8301 MicroMessenger/6.6.0 MiniGame NetType/WIFI Language/").concat(language);
export var navigator = {
  platform: platform,
  language: language,
  appVersion: "5.0 (".concat(uaDesc, ") AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1"),
  userAgent: ua
};
//# sourceMappingURL=navigator.js.map